import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

import { normalizeVideo } from 'shared/redux/helpers/normalized';


const ACTIONS = createAsyncActions('SERVER.CHANNEL.VIDEO.UPDATE');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function (id, data) {
  return function (dispatch) {
    dispatch(START(data, { data: normalizeVideo(data) }));

    return vodAdapter.listItems.update(id, data)
      .then(
        function (response) {
          response = {
            ...response,
            data: normalizeVideo(response.data),
          };

          dispatch(SUCCESS(data, response));
          return response;
        },

        function (error) {
          dispatch(FAIL(data, null, { analytics: { type: 'error', name: 'dashboard.channel.video.update' } }));
          return error;
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/dashboard/redux/server/actions/channel/video/update.js